import { SFSGenderOptions } from './helpers';

export const getPetPossessivePronouns = (genderInput: SFSGenderOptions) => {
  switch (genderInput) {
    case 'UNKN':
      return 'Their';
    case 'MALE':
      return 'His';
    case 'FMLE':
      return 'Her';
    default:
      return 'Their';
  }
};

export const getPetObjectPronouns = (genderInput: SFSGenderOptions) => {
  switch (genderInput) {
    case 'UNKN':
      return 'them';
    case 'MALE':
      return 'him';
    case 'FMLE':
      return 'her';
    default:
      return 'them';
  }
};
